import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Yokohama from "../pages/yokohama/page";
import Pricing from "../pages/pricing/page";
import FirstTime from "../pages/first-time/page";
import FAQ from "../pages/faq/page";
import Access from "../pages/access/page";
import Baggage from "../pages/baggage/page";
import Flow from "../pages/flow/page";
import BookingFlow from "../pages/booking-flow/page";
import CancelPolicy from "../pages/cancel-policy/page";
import Company from "../pages/company/page";
import Contact from "../pages/contact/page";
import Gift from "../pages/gift/page";
import Column from "../pages/column/page";
import ColumnDetail from "../pages/column-detail/page";
import Reviews from "../pages/reviews/page";
import News from "../pages/news/page";
import Privacy from "../pages/privacy/page";
import Tokushoho from "../pages/tokushoho/page";
import Sitemap from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/yokohama",
    element: <Yokohama />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/first-time",
    element: <FirstTime />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/access",
    element: <Access />,
  },
  {
    path: "/baggage",
    element: <Baggage />,
  },
  {
    path: "/flow",
    element: <Flow />,
  },
  {
    path: "/booking-flow",
    element: <BookingFlow />,
  },
  {
    path: "/cancel-policy",
    element: <CancelPolicy />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/gift",
    element: <Gift />,
  },
  {
    path: "/column",
    element: <Column />,
  },
  {
    path: "/column/:slug",
    element: <ColumnDetail />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/tokushoho",
    element: <Tokushoho />,
  },
  {
    path: "/sitemap",
    element: <Sitemap />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
